import {
  Array,
  Record,
  String,
  Optional,
  Tuple,
  Number,
} from 'runtypes';

import { get } from 'utils/fetch';

const AreaRecord = Record({
  id: String,
  name: String,
  stations: Array(String),
  // to be implemented by API:
  coordinates: Optional(Tuple(Number, Number)),
  zoom: Optional(Number),
});

const AreaResponse = Record({
  entities: Array(AreaRecord),
  message: String,
});

export interface AreasResult {
  areas: Area[];
  selected?: Area['id'];
}

export const fetchAreas = (): Promise<AreasResult> => get('/area')
  .then((results) => {
    const { entities: areas } = AreaResponse.check(results);

    const selected = areas[0];

    return { areas, selected: selected.id };
  });
